var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.222 0.77804C16.2593 1.81543 16.2593 3.49736 15.222 4.53475L5.41128 14.3454C4.98573 14.771 4.45252 15.0729 3.86867 15.2188L0.825771 15.9796C0.339398 16.1012 -0.101161 15.6606 0.0204327 15.1742L0.781158 12.1313C0.927121 11.5475 1.22902 11.0143 1.65457 10.5887L11.4652 0.77804C12.5026 -0.259347 14.1846 -0.259347 15.222 0.77804ZM10.526 3.59543L2.59374 11.5279C2.33841 11.7832 2.15728 12.1032 2.0697 12.4535L1.57742 14.4226L3.54654 13.9303C3.89685 13.8427 4.21677 13.6616 4.4721 13.4063L12.404 5.4735L10.526 3.59543ZM12.4044 1.71722L11.465 2.6564L13.3431 4.53447L14.2828 3.59557C14.8015 3.07688 14.8015 2.23591 14.2828 1.71722C13.7641 1.19852 12.9231 1.19852 12.4044 1.71722Z",
    fill: "#DFF6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.2dd4fffc0da8624f74aa3ca6306e251e.svg";
export { ForwardRef as ReactComponent };